export const REDUCER_NAME="refundSlice"
export interface iRefundResponse {
    refund_id: string;
    refundAmount: string;
    refundReason: string;
    status: string;
    CreatedAt: string;
    orderNumber: string;
    customerName: string;
    customerEmail: string;
    productName: string;
    categoryName: string;
    productPrice: string;
}

export interface iUpdateRefund{
    refundReason?:string,
    status?:string

}

export interface iRefundState {
    refundList: iRefundResponse[] | null;
    isLoading: boolean;
    errorMessage: string | null;
    refundDetail:iRefundResponse
}
